module.exports = __webpack_public_path__ + "img/scenes_11.b63fe8b8.png";